import ReactMarkdown from 'react-markdown';

const MESSAGE_MARKDOWN_COMPONENTS = {
  p: ({ children }) => <p className="mb-4 last:mb-0 leading-relaxed">{children}</p>,
  ul: ({ children }) => <ul className="mb-4 last:mb-0 list-disc space-y-2 pl-4">{children}</ul>,
  ol: ({ children }) => <ol className="mb-4 last:mb-0 list-decimal space-y-2 pl-4">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  h1: ({ children }) => <h1 className="mb-3 mt-4 text-xl font-semibold first:mt-0">{children}</h1>,
  h2: ({ children }) => <h2 className="mb-3 mt-4 text-lg font-semibold first:mt-0">{children}</h2>,
  h3: ({ children }) => <h3 className="mb-2 mt-3 text-base font-semibold first:mt-0">{children}</h3>,
  strong: ({ children }) => <strong className="font-semibold text-white">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  code: ({ inline, children }) =>
    inline ? (
      <code className="rounded bg-zinc-800 px-1.5 py-0.5 font-mono text-sm text-zinc-200">{children}</code>
    ) : (
      <code className="mb-4 block overflow-x-auto rounded-sm bg-zinc-900 p-3 font-mono text-sm">{children}</code>
    ),
  pre: ({ children }) => <pre className="mb-4 last:mb-0">{children}</pre>,
  blockquote: ({ children }) => (
    <blockquote className="mb-4 last:mb-0 border-l-2 border-zinc-600 pl-4 italic text-zinc-400">
      {children}
    </blockquote>
  ),
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-400 underline hover:text-blue-300">
      {children}
    </a>
  ),
};

export const MarkdownMessageContent = ({ content }) => (
  <div className="prose prose-invert prose-sm max-w-none break-words">
    <ReactMarkdown components={MESSAGE_MARKDOWN_COMPONENTS}>{content}</ReactMarkdown>
  </div>
);
